import { GET_TOOL_TYPES_LOADING, GET_TOOL_TYPES_SUCCESS } from '../actionTypes';
import store from '../store';
import { showUnknownError } from './keyboard-shortcuts.actions';
import { client } from '../../services/client';

export const getToolTypesSuccess = payload => {
    return ({
        type: GET_TOOL_TYPES_SUCCESS,
        payload
    })
}

export const getToolTypesAsync = payload => dispatch => {
    return client.service('tool-types').find()
		.then((response) => {
            dispatch(getToolTypesSuccess(response));
            return response
		})
        .catch((error) => {
            console.error('error', error);
        })
           
}